import { IconProps } from 'types/icon.type'

export const MoonIcon = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Moon Icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.355 3.91566C9.31038 4.12823 8.3116 4.54232 7.41655 5.14038C6.05984 6.0469 5.00242 7.33537 4.378 8.84286C3.75358 10.3504 3.5902 12.0092 3.90853 13.6095C4.22685 15.2098 5.01259 16.6798 6.16637 17.8336C7.32016 18.9874 8.79017 19.7732 10.3905 20.0915C11.9909 20.4098 13.6497 20.2464 15.1571 19.622C16.6646 18.9976 17.9531 17.9402 18.8596 16.5835C19.4577 15.6884 19.8718 14.6896 20.0843 13.645C19.0056 14.2742 17.7703 14.614 16.5 14.614C14.6133 14.614 12.8038 13.8645 11.4697 12.5303C10.1355 11.1962 9.38604 9.38674 9.38604 7.5C9.38604 6.2297 9.7258 4.99442 10.355 3.91566ZM6.58319 3.89317C8.18657 2.82183 10.0716 2.25 12 2.25C12.3034 2.25 12.5768 2.43273 12.6929 2.71299C12.809 2.99324 12.7448 3.31583 12.5303 3.53033C11.4775 4.58315 10.886 6.01109 10.886 7.5C10.886 8.98891 11.4775 10.4168 12.5303 11.4697C13.5832 12.5225 15.0111 13.114 16.5 13.114C17.9889 13.114 19.4169 12.5225 20.4697 11.4697C20.6842 11.2552 21.0068 11.191 21.287 11.3071C21.5673 11.4232 21.75 11.6967 21.75 12C21.75 13.9284 21.1782 15.8134 20.1068 17.4168C19.0355 19.0202 17.5127 20.2699 15.7312 21.0078C13.9496 21.7458 11.9892 21.9389 10.0979 21.5627C8.20656 21.1865 6.46927 20.2579 5.10571 18.8943C3.74215 17.5307 2.81355 15.7934 2.43735 13.9021C2.06114 12.0108 2.25422 10.0504 2.99218 8.26884C3.73013 6.48726 4.97982 4.96452 6.58319 3.89317Z"
        fill="currentColor"
      />
    </svg>
  )
}
